import { ACTIONS } from 'redux/actions/actions'
import addLogs from 'redux/reducers/log/addLogs'

export default { [ACTIONS.ADD_LOGS]: addLogs }
